(() => {

    const FILTER = document.querySelector('.filter-container--wrapper')
    const TRIGGER = document.querySelector('.filter-trigger')

    if(!FILTER || !TRIGGER) return

    // Get max height based on actual height of the content ( makes animation nicer than fixed amount in CSS )
    const container = FILTER.children[0]
    const containerStyle = container.currentStyle || window.getComputedStyle(container)

    function toggleOpen() {
        FILTER.classList.toggle('active')

        FILTER.style.maxHeight = 0

        if(Array.from(FILTER.classList).indexOf('active') > -1) {
            FILTER.style.maxHeight = `${parseInt(containerStyle.height) + parseInt(containerStyle.marginTop)}px`
        }
    }

    TRIGGER.addEventListener('click', toggleOpen)

})()
